import styles from '../../../MultiStepPMSLogin.module.scss'
import security from './security.png'

const SecurityQuestions = () => {
  return (
    <div className={styles.solutionContainer}>
      <p className={styles.descriptionText}>
        You can set the security questions from the security questions section.
      </p>
      <img src={security} width={'500px'} alt="" />
    </div>
  )
}

export default SecurityQuestions
